import { Box, Button, Flex, HStack, Text, useDisclosure } from '@televet/kibble-ui';
import { useTracking } from 'shared/providers/TrackingProvider';
import { format } from 'date-fns';
import React from 'react';
import { LoyaltyEvents } from 'shared/providers/TrackingProvider/EventNames';
import { LoyaltyReward } from 'shared/types/graphql';
import { RewardActionModal } from './RewardActionModal';

interface RewardCardProps {
  reward: Pick<LoyaltyReward, 'title' | 'id' | 'description' | 'pointCost'>;
  rewardRedemptionId?: string;
  requestedDate?: Date;
  showButton?: boolean;
  accountId: string;
  triggerRefetch?: () => void;
}

export const RewardCard = ({
  reward,
  rewardRedemptionId,
  requestedDate,
  showButton = true,
  accountId,
  triggerRefetch,
}: RewardCardProps): JSX.Element => {
  const { trackEvent } = useTracking();
  const {
    isOpen: isRewardActionModalOpen,
    onOpen: openRewardActionModal,
    onClose: closeRewardActionModal,
  } = useDisclosure();

  return (
    <>
      <Box p={4} border="1px" borderColor="border.default" borderRadius="base" bgColor="background.default">
        <Flex mb={2} justifyContent="space-between">
          <Flex flex={1}>
            <Text isTruncated fontWeight="bold" noOfLines={2} size="sm">
              {reward.title}
            </Text>
          </Flex>
          {requestedDate && (
            <HStack>
              <Text size="xs" ml={2} lineHeight="21px">
                Requested:
              </Text>
              <Text size="xs" variant="info">
                {format(new Date(requestedDate), 'MM/dd/yy ')}
              </Text>
            </HStack>
          )}
        </Flex>
        <Text variant="subtle" size="sm">
          {reward.description}
        </Text>
        {showButton && (
          <Button
            size="xs"
            isFullWidth
            mt={2}
            onClick={(): void => {
              trackEvent(
                requestedDate ? LoyaltyEvents.SidepanelFulfillRewardClick : LoyaltyEvents.SidepanelClaimRewardClick,
                {
                  ...(!requestedDate && { rewardCost: reward.pointCost }),
                },
              );
              openRewardActionModal();
            }}
          >
            {requestedDate ? 'Fulfill' : 'Claim'} Reward
          </Button>
        )}
      </Box>
      {isRewardActionModalOpen && (
        <RewardActionModal
          isOpen={isRewardActionModalOpen}
          onClose={closeRewardActionModal}
          reward={reward}
          rewardRedemptionId={rewardRedemptionId}
          requestedDate={requestedDate}
          accountId={accountId}
          triggerRefetch={triggerRefetch}
        />
      )}
    </>
  );
};
